import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { PerimeterXUserData, type PerimeterXUserDataQuery, type PerimeterXUserDataQueryVariables } from './api.graphql';

export async function getPerimeterXUserData({
	gql: { fetch },
}: UtilityContext): Promise<PerimeterXUserDataQuery['viewer']['perimeterXConfig']> {
	const { data } = await fetch<PerimeterXUserDataQuery, PerimeterXUserDataQueryVariables>({
		query: PerimeterXUserData,
		batched: false,
		rejectOnError: true,
	});
	return data.viewer.perimeterXConfig;
}
